import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-766fe908"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fs-sm"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Es existieren keine Anhänge ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "row d-flex" }
const _hoisted_7 = ["id", "src", "alt"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["id", "src", "alt"]
const _hoisted_11 = {
  key: 2,
  class: "d-flex justify-content-center pe-2"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  class: "thumbnail-title fw-bold text-center",
  style: {"color":"white"}
}
const _hoisted_16 = { class: "bms-attachments" }
const _hoisted_17 = ["id", "src", "alt"]
const _hoisted_18 = ["id"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"2px","text-align":"center"} }, null, -1))

import useStringManip from '@/composables/general/useStringManip';
import { convertFiletoBlobAndDownload } from '@/composables/general/useUtils';
import useSetContentTypeToCssClass from '@/composables/message/useSetContentTypeToCssClass';
import { Attachment } from '@/models/message.model';
import { computed, ref } from '@vue/runtime-core';
import Galleria from 'primevue/galleria';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  messageAttachments: {
    type: Object as PropType<Attachment[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "fafd85b2": (_unref(navIconDisplay))
}))



const { truncate } = useStringManip();
const { assignContentTypeToCssClass } = useSetContentTypeToCssClass();
// +----------------+
// |   Variables    |
// +----------------+
const activeIndex = ref(0);
const displayCustom = ref(false);
const responsiveOptions = [
  {
    breakpoint: '1224px',
    numVisible: 3,
  },
  {
    breakpoint: '1000px',
    numVisible: 2,
  },
  {
    breakpoint: '560px',
    numVisible: 1,
  },
];

// +----------------+
// |    Computed    |
// +----------------+

const processedAttachments = computed((): Attachment[] => {
  if (!props.messageAttachments) return [];
  return props.messageAttachments
    .filter(att => att.content_type.match('url') == null && att.tag !== 'removed' && att.tag !== 'edited_picture')
    .sort((a, b) => {
      return -a.created.localeCompare(b.created);
    });
});

const navIconDisplay = computed((): string => (processedAttachments.value.length == 1 ? 'none' : ''));

// +----------------+
// |   Functions    |
// +----------------+
function changeIndex(index: number) {
  activeIndex.value = index;
}

function imageClick(index: number) {
  activeIndex.value = index;
  displayCustom.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_unref(processedAttachments).length == 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : (_openBlock(), _createElementBlock("span", _hoisted_5, [
        _createVNode(_unref(Galleria), {
          visible: displayCustom.value,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((displayCustom).value = $event)),
          value: _unref(processedAttachments),
          activeIndex: activeIndex.value,
          responsiveOptions: responsiveOptions,
          numVisible: 7,
          containerStyle: "max-height:100%;",
          circular: true,
          fullScreen: true,
          showItemNavigators: true,
          showThumbnails: false,
          "onUpdate:activeIndex": changeIndex
        }, {
          item: _withCtx((slotProps) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                (slotProps.item.thumbnails !== null && slotProps.item.tag == 'picture')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      id: slotProps.item.id,
                      class: "full-image",
                      src: slotProps.item.url,
                      alt: `Anhang ID ${slotProps.item.id}`
                    }, null, 8, _hoisted_7))
                  : (slotProps.item.thumbnails !== null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createElementVNode("a", {
                          role: "button",
                          target: "_blank",
                          onClick: ($event: any) => (_unref(convertFiletoBlobAndDownload)(slotProps.item))
                        }, [
                          _createElementVNode("img", {
                            id: slotProps.item.id,
                            class: "full-image",
                            src: slotProps.item.thumbnails?.w800,
                            alt: `Anhang ID ${slotProps.item.id}`
                          }, null, 8, _hoisted_10)
                        ], 8, _hoisted_9)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["bi text-white", _unref(assignContentTypeToCssClass)('iconClass', slotProps.item.content_type)]),
                          role: "button",
                          target: "_blank",
                          style: {"font-size":"8rem"},
                          onClick: ($event: any) => (_unref(convertFiletoBlobAndDownload)(slotProps.item))
                        }, null, 10, _hoisted_12)
                      ]))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(slotProps.item.title ?? slotProps.item.filename), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible", "value", "activeIndex"]),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processedAttachments), (attachment) => {
            return (_openBlock(), _createElementBlock("div", {
              key: attachment.id,
              class: "wdw-attachment"
            }, [
              (attachment.thumbnails !== null && typeof activeIndex.value == 'number')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    id: attachment.id.toString(),
                    class: "image",
                    role: "button",
                    src: attachment.thumbnails?.sq128,
                    alt: `Anhang ID ${attachment.id}`,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (imageClick(activeIndex.value)))
                  }, null, 8, _hoisted_17))
                : (typeof activeIndex.value == 'number')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      id: attachment.id.toString(),
                      class: "d-flex flex-column align-items-center p-5",
                      role: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (imageClick(activeIndex.value)))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi", _unref(assignContentTypeToCssClass)('iconClass', attachment.content_type)]),
                        style: {"font-size":"4rem"}
                      }, null, 2),
                      _withDirectives(_createElementVNode("div", {
                        class: "text-center fs-sm",
                        style: {"color":"black"}
                      }, _toDisplayString(attachment.title
                ? _unref(truncate)(attachment.title, 30, true)
                : attachment.filename
                ? _unref(truncate)(attachment.filename, 30, true)
                : ''), 513), [
                        [_vShow, attachment.tag !== 'picture']
                      ])
                    ], 8, _hoisted_18))
                  : _createCommentVNode("", true),
              _hoisted_19
            ]))
          }), 128))
        ])
      ]))
}
}

})